import { styled } from '../jss-style';
import selectStyle from './select';

const useSelectStyle = styled(selectStyle, 'select');
export { selectStyle, useSelectStyle };
export default useSelectStyle;
